import axios, { AxiosResponse, AxiosError } from "axios";

const api = axios.create({
  timeout: 10_000,
});

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error.response?.status;
    if (status === 500) {
      console.error("[api] Server error:", error.response?.data);
    }
    if (status === 401 && typeof window !== "undefined") {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
